exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#master-sidebar[data-v-1161dad4]{width:300px;z-index:8}.router-link-header[data-v-1161dad4]{padding:1em .75em 0;text-transform:uppercase;font-size:.9em;font-weight:600;width:100%;color:#aaa}.settings-nav-section .router-link-header[data-v-1161dad4]{padding-top:.5em}.router-link[data-v-1161dad4]{padding:.5em .75em .5em 1.25em;margin:0;display:flex;justify-content:space-between;align-items:center;text-decoration:none;transition:all .25s ease}.router-link.router-link-exact-active[data-v-1161dad4]{background:rgba(0,0,0,.05)}.router-link[data-v-1161dad4]:hover{background:rgba(0,0,0,.1);padding-right:1em}.settings-nav-section[data-v-1161dad4]{border-top:3px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1161dad4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/master-sidebar.vue
// module id = 189
// module chunks = 0